<template>
  <div
    class="flow-add-button"
    :class="{
      'flow-add-button--closure-selectable': closureSelectable,
      'flow-add-button--closure-selected': closureSelected,
      'flow-add-button--hidden': closureMode && !closureSelectable && !closureSelected,
    }"
    :style="buttonStyle"
    @click.stop="$emit('click')"
  >
    <i v-if="!closureMode" class="far fa-plus" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'FlowAddButton',
  props: {
    top: {
      type: Number,
      required: true,
    },
    left: {
      type: Number,
      required: true,
    },
    closureMode: {
      type: Boolean,
      default: false,
    },
    closureSelectable: {
      type: Boolean,
      default: false,
    },
    closureSelected: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],

  setup(props) {
    const buttonStyle = computed(() => ({
      top: `${props.top}px`,
      left: `${props.left}px`,
    }));

    return {
      buttonStyle,
    };
  },
});
</script>

<style lang="scss" scoped>
.flow-add-button {
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #d1d5db;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
  transform: translate(-50%, -50%);
  z-index: 10;

  i {
    color: #6b7280;
    font-size: 0.65rem;
    font-weight: 600;
  }

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
    border-color: #9ca3af;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  }

  // Hidden state in closure mode
  &--hidden {
    opacity: 0.3;
    pointer-events: none;
  }

  // Closure selectable state - orange highlight
  &--closure-selectable {
    background: #FFC56E;
    border-color: #FFC56E;
    box-shadow: 0 0 0 3px rgba(255, 197, 110, 0.4), 0 3px 8px rgba(0, 0, 0, 0.15);
    animation: pulse-closure 1.5s infinite;

    &:hover {
      transform: translate(-50%, -50%) scale(1.2);
      box-shadow: 0 0 0 4px rgba(255, 197, 110, 0.6), 0 4px 12px rgba(0, 0, 0, 0.2);
    }
  }

  // Closure selected state - green highlight
  &--closure-selected {
    background: #93c840;
    border-color: #93c840;
    box-shadow: 0 0 0 3px rgba(147, 200, 64, 0.4), 0 3px 8px rgba(0, 0, 0, 0.15);
    animation: none;

    &:hover {
      transform: translate(-50%, -50%) scale(1.2);
      box-shadow: 0 0 0 4px rgba(147, 200, 64, 0.6), 0 4px 12px rgba(0, 0, 0, 0.2);
    }
  }
}

@keyframes pulse-closure {
  0%, 100% {
    box-shadow: 0 0 0 3px rgba(255, 197, 110, 0.4), 0 3px 8px rgba(0, 0, 0, 0.15);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(255, 197, 110, 0.2), 0 3px 8px rgba(0, 0, 0, 0.15);
  }
}
</style>
